module.exports = __webpack_public_path__ + "static/media/green_temp.3b72b876.svg";